import React from "react";
import Styles from './styles.module.scss';
import {useTranslation} from "react-i18next";

import s3Arrow from '../../theme/assets/other/ftf_main_s3_arrow.png';


const MainS3 = () => {
    const { t } = useTranslation();
    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.elementWidthWP}`}>
                <div className={`${Styles.contentWrapTitle}`}>{t('Крипто-рынок превратился в цирк')}!</div>
                <div className={`${Styles.contentWrapSubTitle}`}>{t('Крипто-технологии < Крипто цирк')}!</div>
                <div className={`${Styles.contentBox}`}>
                    <div className={`${Styles.contentBoxList}`}>
                        <div className={`${Styles.contentBoxListItem}`}>{t('Децентрализация')}</div>
                        <div className={`${Styles.contentBoxListItem}`}>{t('Свобода и не зависимость')}</div>
                        <div className={`${Styles.contentBoxListItem}`}>{t('Прозрачность и открытость')}</div>
                        <div className={`${Styles.contentBoxListItem}`}>{t('Безопасность и доверие без посредников')}</div>
                        <div className={`${Styles.contentBoxListItem}`}>{t('Естественный рост')}</div>
                    </div>
                    <div className={`${Styles.contentBoxListSeparator}`}><img src={s3Arrow} alt="arrow"/></div>
                    <div className={`${Styles.contentBoxList} ${Styles.contentBoxListRed}`}>
                        <div className={`${Styles.contentBoxListItem}`}>{t('Манипуляции')}</div>
                        <div className={`${Styles.contentBoxListItem}`}>{t('Rug pull')}</div>
                        <div className={`${Styles.contentBoxListItem}`}>{t('Pump and dump')}</div>
                        <div className={`${Styles.contentBoxListItem}`}>{t('Отмывание денег')}</div>
                        <div className={`${Styles.contentBoxListItem}`}>{t('Инсайдерская торговля')}</div>
                    </div>
                </div>
                <div className={`${Styles.contentWrapNote}`}>{t('Пора положить этому конец и вернуть истинную ценность на крипто-рынок')}!</div>
                <div className={`${Styles.ftfBackgroundBtn}`}>{t('Прекратить клоунаду!')}</div>
            </div>
        </section>
    );
};

export default MainS3;
